import React, { useMemo } from 'react';
import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import styles from './blogMainPage.module.sass';
import { Text } from '../Text';
import { RadioButton } from '../RadioButton';
import { CardNews } from '../CardNews';
import { PartnersBanners } from '../Banner/PartnersBanner/PartnersBanners';
import { Button } from '../Button';
import { SkeletonNewsCard } from '../Skeleton/SkeletonNewsCard';
import { useBlogStore } from '../../providers/RootStoreProvider';
import { IconSVG } from '../SpriteSVG';
import { Icon } from '../Icon';

export const BlogMainPage = observer(({ isMobile, isTablet, banners }) => {
  const store = useBlogStore();

  const { loading: isLoading } = store;

  const router = useRouter();

  const allMedia = useMemo(
    () => [
      ...[
        {
          id: 'all',
          label: 'Все',
        },
      ],
      ...store.data.media_list.map(({ id, label }) => ({
        id: String(id),
        label,
      })),
    ],
    [store.data.media_list],
  );

  const onShowMore = () => {
    store.loadMorePosts({ page: store.page + 1, media: store.media });
  };

  return (
    <>
      <div className={styles.contact}>
        <Text component="h1" variant="heading-lg" bottomGap={24}>
          Полезные советы и статьи о круизах
        </Text>
      </div>
      <div className={styles.wrapper}>
        <Formik
          initialValues={{
            blogNewsType: '1',
          }}
        >
          {() => (
            <Form className={styles.form}>
              <RadioButton
                options={
                  allMedia?.map(({ id, label }) => ({ value: id, label })) ?? []
                }
                name={'blogNewsType'}
                filter
                actionOnClick={e => {
                  router.replace({ query: { media: e } }, undefined, {
                    shallow: true,
                  });
                  store.loadPosts({ page: 1, media: e });
                }}
                values={router.query?.media ?? 'all'}
              />
            </Form>
          )}
        </Formik>

        {!isLoading ? (
          <>
            {!store.data?.posts_list?.filter(Boolean).length && (
              <div className={styles.notFound}>
                <Icon
                  width={48}
                  height={48}
                  icon={
                    <IconSVG name={'emoji/sadFace'} width={48} height={48} />
                  }
                  title="Грусть, тоска"
                />
                <Text
                  component="h3"
                  variant="heading-2"
                  bottomGap={24}
                  topGap={16}
                >
                  Посты не найдены :(
                </Text>
              </div>
            )}
            {router.query?.media === 'all' || !router.query.media ? (
              <div className={styles.firstGrid}>
                {(store.data?.posts_list?.filter(Boolean) ?? [])
                  .slice(0, 5)
                  .map((i, key) =>
                    key === 0 ? (
                      <CardNews
                        key={key}
                        array={i}
                        link={`/blog/${i?.link}`}
                        size={'xl'}
                        isMobile={isMobile}
                      />
                    ) : (
                      <CardNews
                        key={key}
                        array={i}
                        link={`/blog/${i?.link}`}
                        isMobile={isMobile}
                      />
                    ),
                  )}
              </div>
            ) : (
              <div className={styles.secondGrid}>
                {(store.data?.posts_list?.filter(Boolean) ?? [])
                  .slice(0, 4)
                  .map((i, key) => (
                    <CardNews
                      key={key}
                      array={i}
                      link={`/blog/${i?.link}`}
                      isMobile={isMobile}
                    />
                  ))}
              </div>
            )}

            <PartnersBanners
              isMobile={isMobile}
              isTablet={isTablet}
              banners={banners}
            />
            {router.query?.media === 'all' || !router.query.media ? (
              <div className={styles.secondGrid}>
                {(store.data?.posts_list?.filter(Boolean) ?? [])
                  .slice(5)
                  .map((i, key) => (
                    <CardNews
                      key={key}
                      array={i}
                      link={`/blog/${i?.link}`}
                      isMobile={isMobile}
                    />
                  ))}
              </div>
            ) : (
              <div className={styles.secondGrid}>
                {(store.data?.posts_list?.filter(Boolean) ?? [])
                  .slice(4)
                  .map((i, key) => (
                    <CardNews
                      key={key}
                      array={i}
                      link={`/blog/${i?.link}`}
                      isMobile={isMobile}
                    />
                  ))}
              </div>
            )}

            <div className={styles.button}>
              {store.data?.total_pages > store.page && (
                <Button
                  view="textResult"
                  size="very-large"
                  onClick={onShowMore}
                  className={styles.buttonWrapper}
                >
                  Показать еще
                </Button>
              )}
            </div>
          </>
        ) : (
          <div className={styles.secondGrid}>
            <SkeletonNewsCard />
            <SkeletonNewsCard />
            <SkeletonNewsCard />
            <SkeletonNewsCard />
            <SkeletonNewsCard />
            <SkeletonNewsCard />
          </div>
        )}
      </div>
    </>
  );
});
